<template>
  <o-dialog
    ref="dialog"
    :title="$t('general.sendEmail')"
    :info="$t('components.waitlist.actions.email.info')"
    :options="[
      { text: $t('general.back'), type: 'cancel' },
      { text: $t('general.sendEmail'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Waitlist } from '~/_api/models/waitlist'

interface Props {
  portal?: string | null
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
}

withDefaults(defineProps<Props>(), {
  portal: null,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const waitlist = ref<Waitlist | null>(null)

const open = (item: Waitlist) => {
  waitlist.value = item

  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.waitlist.email(waitlist.value!)

    if (response.success) {
      $notification.toast({
        title: $i18n.t('general.messageSent'),
        text: $i18n.t('components.waitlist.actions.email.successInfo'),
        variant: 'success',
      })

      return true
    }

    $notification.error({ errors: response.errors })
  } catch (e: any) {
    $notification.error({ errors: e?.errors })
  } finally {
    emit('update:loading', false)
  }

  return false
}

defineExpose({ open })
</script>
